import React from 'react'
import Loginstr from "./Loginstr"
const Login = () => {
  return (
    <div>
        <Loginstr/>
    </div>
  )
}

export default Login